<script>
import 'vue-select/dist/vue-select.css'
import { required } from 'vuelidate/lib/validators'
import DatePicker from 'vue2-datepicker'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'

export default {
  name: 'MultiDuplicates',
  props: {
    idsSeleted: [Object, Array],
  },
  components: {
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      loadingData: false,
      companyUsers: [],
      companyUser: [],
      errorShow: false,
      error: '',
    }
  },
  validations: {
    companyUser: { required },
  },
  computed: {},
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Field is required')
        response = false
      }
      return response
    },
    getData() {
      this.loadingData = true
      axiosGetPost('post', '/localCharges/getSelects').then((response) => {
        const data = response.data
        console.log(data)
        this.companyUsers = data.company_users
        this.loadingData = false
        return data
      })
    },
    duplicate() {
      if (this.validate_fields()) {
        this.loadingData = true
        axiosGetPost('post', '/localCharges/duplicateLocals', {
          data: {
            ids: this.idsSeleted,
            company_user_id: this.companyUser.map((item) => item.id),
          },
        }).then((response) => {
          this.loadingData = false
          console.log(response)
          if (response.success) {
            this.$toastr.s(response.messages)
            this.$emit('closeModal')
          } else {
            this.errorShow = true
            this.error = 'Error to save'
            this.$toastr.e('Error Duplicating. JOB')
          }
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="col-12">
      <div
        v-if="loadingData"
        class="row align-items-center justify-content-center"
        style="height: 300px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="primary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>
      <div v-else-if="errorShow === true">
        <div
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <feather type="frown" class="icon-xxl icon-dual-info"></feather>
            <h6 class="text-muted">{{ error }}</h6>
          </div>
        </div>
      </div>
      <div v-else-if="!loadingData">
        <div class="form-group row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label>Company User</label>
            <multiselect
              id="companyUser"
              v-model="companyUser"
              :options="companyUsers"
              select-label=""
              placeholder="Select companies"
              label="name"
              track-by="name"
              class="mt-0 mt-sm-0 mb-0"
              :multiple="true"
              required
            >
            </multiselect>
            <div v-if="$v.companyUser.$error" style="color: red"
              >* This value is required.</div
            >
          </div>
          <div class="col-md-5">
            <label>Data</label>
            <div class="m-2">
              {{ idsSeleted.length }} - Globalchargers selected
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <b-button variant="primary" class="col-4" @click="duplicate"
              >Submit</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
